export { default } from './TaRatingCircle';